import script from "./TaskRecurrenceEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskRecurrenceEditor.vue?vue&type=script&setup=true&lang=js"

import "./TaskRecurrenceEditor.vue?vue&type=style&index=0&id=6225b127&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6225b127"]])

export default __exports__